export default "__VITE_ASSET__CfFXVQNw__"